import { useCallback } from "react";
import useApiCall from "hooks/useApiCall";
import { verifyResetPassword } from "api/services/user-service";

export const useVerifyResetPassword = () => {
    const { callAPI, loading } = useApiCall(verifyResetPassword, '', '');

    const fetchVerifyResetPassword = useCallback(async (email: string, token: string) => {
        const resp = await callAPI({ email, token });
        return resp;
    }, [callAPI]);

    return { fetchVerifyResetPassword, fetchingResetPasswordStatus: loading };
}